import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const MobileNewsCategories = () => {
  const { t } = useTranslation();

  const categoriesData = [
    { 
      name: t('sidebar.national', 'राष्ट्रीय'), 
      path: '/category/national', 
      image: '/category_images/cat_national_1786623538113.jpg',
      subcategories: [
        { name: t('sidebar.state', 'राज्य'), path: '/category/state' },
        { name: t('sidebar.district', 'ज़िला'), path: '/category/district' },
        { name: t('sidebar.election', 'चुनाव'), path: '/category/election' }
      ]
    },
    { 
      name: t('sidebar.international', 'अंतरराष्ट्रीय'), 
      path: '/category/international', 
      image: '/category_images/cat_international_1786623548563.jpg',
      subcategories: []
    },
    { 
      name: t('sidebar.politics', 'राजनीति'), 
      path: '/category/politics', 
      image: '/category_images/cat_politics_1786623563412.jpg',
      subcategories: []
    },
    { 
      name: t('sidebar.business', 'व्यापार'), 
      path: '/category/business', 
      image: '/category_images/cat_business_1786623576385.jpg',
      subcategories: [
        { name: t('sidebar.economy', 'अर्थव्यवस्था'), path: '/category/economy' },
        { name: t('sidebar.stock_market', 'शेयर बाजार'), path: '/category/stock-market' }
      ]
    },
    { 
      name: t('sidebar.entertainment', 'मनोरंजन'), 
      path: '/category/entertainment', 
      image: '/category_images/cat_entertainment_1786623650419.jpg',
      subcategories: [
        { name: t('sidebar.movies', 'फिल्में'), path: '/category/movies' },
        { name: t('sidebar.ott', 'ओटीटी'), path: '/category/ott' }
      ]
    },
    { 
      name: t('sidebar.sports', 'खेल'), 
      path: '/category/sports', 
      image: '/category_images/cat_sports_1786624180358.jpg',
      subcategories: [
        { name: t('sidebar.cricket', 'क्रिकेट'), path: '/category/cricket' }
      ]
    },
    { 
      name: t('sidebar.tech_science', 'टेक/विज्ञान'), 
      path: '/category/technology', 
      image: '/category_images/cat_tech_1786624273593.jpg',
      subcategories: []
    },
    { 
      name: t('sidebar.health', 'स्वास्थ्य'), 
      path: '/category/health', 
      image: '/category_images/cat_health_1786624289026.jpg',
      subcategories: []
    },
    { 
      name: t('sidebar.religion', 'धर्म/ज्योतिष'), 
      path: '/category/religion', 
      image: '/category_images/cat_religion_1786624514462.jpg',
      subcategories: []
    },
    { 
      name: 'गैलरी', 
      path: '#', 
      image: '/category_images/cat_gallery_1786624622324.jpg',
      subcategories: [
        { name: t('header.photos', 'तस्वीरें'), path: '/gallery/photos' },
        { name: t('header.videos', 'वीडियो'), path: '/gallery/videos' }
      ]
    }
  ];

  return (
    <>
      <div className="w-full max-w-[1400px] mx-auto px-4 py-6 mb-24 md:hidden">
        
        {/* Improved Hindi Heading */}
        <div className="mb-6">
          <h1 className="text-[26px] leading-tight font-black text-gray-900 border-l-4 border-brand-red pl-3 tracking-wide">
            हमारी विस्तृत <span className="text-brand-purple">न्यूज़ कवरेज</span>
          </h1>
          <p className="text-gray-500 text-sm mt-1 pl-4">अपनी पसंद की खबरें पढ़ने के लिए कैटेगरी चुनें</p>
        </div>
        
        {/* 1 Card per row (grid-cols-1) */}
        <div className="grid grid-cols-1 gap-5">
          {categoriesData.map((cat, index) => (
            <div key={index} className="relative w-full h-48 rounded-xl overflow-hidden shadow-[0_4px_12px_rgba(0,0,0,0.15)] group">
              
              {/* Background Image */}
              <img 
                src={cat.image} 
                alt={cat.name} 
                className="absolute inset-0 w-full h-full object-cover group-active:scale-105 transition-transform duration-500" 
              />
              
              {/* Dark Overlay for text readability */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-black/10"></div>
              
              {/* Main Category Link overlay (covers the whole card) */}
              <Link to={cat.path} className="absolute inset-0 z-10"></Link>

              {/* Content Container (pass-through clicks so the main link works) */}
              <div className="absolute bottom-0 left-0 w-full p-4 z-20 pointer-events-none flex flex-col justify-end">
                
                {/* Main Category Name (clicks pass through to the underlying Link) */}
                <h2 className="text-white text-2xl font-black mb-3 drop-shadow-md">
                  {cat.name}
                </h2>
                
                {/* Subcategories (Chips - must intercept clicks) */}
                {cat.subcategories.length > 0 && (
                  <div className="flex flex-wrap gap-2 pointer-events-auto relative z-30">
                    {cat.subcategories.map((sub, idx) => (
                      <Link 
                        key={idx} 
                        to={sub.path}
                        className="bg-brand-red/90 hover:bg-brand-purple text-white text-[13px] font-semibold px-3 py-1 rounded-full shadow-sm backdrop-blur-sm transition-colors"
                      >
                        {sub.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Desktop warning */}
      <div className="hidden md:flex w-full h-[50vh] items-center justify-center flex-col gap-4">
        <h2 className="text-2xl font-bold text-gray-500">यह पेज केवल मोबाइल के लिए है</h2>
        <Link to="/" className="text-brand-purple hover:underline">होम पेज पर वापस जाएं</Link>
      </div>
    </>
  );
};

export default MobileNewsCategories;
